import type { ScoringResult } from '@mathflat/domain/Scoring'
import type { StudentExamScoringSummaryItem } from '@mathflat/domain/StudentExam'
import { makeObservable, observable } from 'mobx'
import { EMPTY_NUMBER_ID } from 'src/constant/common'
import { UndoableDTO } from 'src/dto/UndoableDTO'

import { typeSafeAssign } from '@/utils/common'

export class ProblemScoringExam extends UndoableDTO {
  examProblemId: number = EMPTY_NUMBER_ID
  result: ScoringResult = 'CORRECT'
  score: number = 0

  constructor(data: Pick<StudentExamScoringSummaryItem, 'examProblemId' | 'result' | 'score'>) {
    super()
    makeObservable(this, {
      examProblemId: observable,
      result: observable,
      score: observable,
    })

    if (data) typeSafeAssign(this, data)
  }
}
